import { render, staticRenderFns } from "./PressRoomList.vue?vue&type=template&id=66271b3c&"
import script from "./PressRoomList.vue?vue&type=script&lang=js&"
export * from "./PressRoomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports